import { useTranslation } from 'react-i18next'

import { ReservationDto } from '@wwt/entities/api/search-response'

import { formatGuestInformationContent } from '../utils/formatGuestInformationContent.ts'
import { getYearsOldByBirthDate } from '../utils/getYearsOldByBirthDate.ts'

export const useGuestInformationRoomGuests = (
	adultsListInput: ReservationDto['adultsList'],
	childrenListInput: ReservationDto['childrenList'],
	petListInput: ReservationDto['petList']
) => {
	const { t } = useTranslation('room-page', {
		keyPrefix: 'reservationTab.guestInfo'
	})

	const adultsList = adultsListInput.map((adult, index) => {
		const age = adult.dateOfBirth
			? t('adult.yearOld', { count: getYearsOldByBirthDate(adult.dateOfBirth) })
			: ''

		return {
			id: index,
			title: t('adult.title', { index: index + 1 }),
			content: formatGuestInformationContent(t, adult.name, adult.lastName, age)
		}
	})

	const childrenList = !childrenListInput
		? []
		: childrenListInput.map((child, index) => {
				const age = t('children.yearOld', {
					count: getYearsOldByBirthDate(child.dateOfBirth)
				})

				return {
					id: index,
					title: t('children.title', { index: index + 1 }),
					content: formatGuestInformationContent(
						t,
						child.name,
						child.lastName,
						age
					)
				}
			})

	const petList = !petListInput
		? []
		: petListInput.map((pet, index) => ({
				id: index,
				title: t('pet.title', { index: index + 1 }),
				content: t('pet.content', {
					type: pet.type,
					weight: pet.weight
				})
			}))

	return {
		adultsList,
		childrenList,
		petList
	}
}
